import React, { useEffect, useState } from "react";
import Sidenavbar from "../Sidenavbar";
import Topbar from "../Topbar";
import "../../styles/CommonStyle.scss";
import "../../styles/SuperAdminPage.scss";
import { Link, useNavigate } from "react-router-dom";
import { loggedInRole } from "../LoginRole";
import AccessDenied from "../../AccessDenied";
import { Button, Col, Form, Row } from "react-bootstrap";
import { TbTrekking, TbActivityHeartbeat } from "react-icons/tb";
import { AiOutlineArrowRight } from "react-icons/ai";
import { GiCreditsCurrency } from "react-icons/gi";
import { useRef } from "react";
import { loadAdminAccess, loadGetOTP, loadLeadsCardData, loadLeadsTableData, loadSupportAccess } from "../../redux/action";
import { useDispatch, useSelector } from "react-redux";
import { SBSaveUpdateBtn } from "../SbButtons/SbAddBtn";
import OTPTimer from "./OTPTimer";
import * as HeaderAuthentication from "../../Components/HeaderAuthentication";
import moment from "moment/moment";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import SkeletonTableData from "../Skeleton Loading/SkeletonTableData";
import { getRandomColor } from "../FormattedAmount";

export default function SuperAdminPage() {

  let tableHeader = [
    { name: "NAME", align: "left", width: "150px" },
    { name: "TRIAL", align: "left", width: "150px" },
    { name: "TIER", align: "left", width: "150px" },
    { name: "ELITE", align: "left", width: "150px" },
  ]
  const [isLoading, setIsLoading] = useState(false);

  let themeColor = localStorage.getItem("theme");

  const [adimnStatus, setAdminStatus] = useState(false);
  const [otpError, setOtpError] = useState(false);
  let dispatch = useDispatch();

  const { access } = useSelector((state) => state.data);
  const { supportAccess } = useSelector((state) => state.data);
  const { otpData } = useSelector((state) => state.data);
  const { getLeadsCardData } = useSelector((state) => state.data);
  const { getLeadsTableData } = useSelector((state) => state.data);
  console.log(getLeadsTableData, 'getLeadsTableData')

  let userDetails = JSON.parse(sessionStorage.getItem("usdtls"));

  const [menuCollapse, setMenuCollapse] = useState(false);
  const [toggleshift, setToggleshift] = useState({ style: "" });

  const toggleMenu = () => {
    if (menuCollapse) {
      setMenuCollapse(false);
      setToggleshift({ style: "" });
    } else {
      setMenuCollapse(true);
      setToggleshift({ style: "toggle-shift-left" });
    }
  };

  const [otp, setOtp] = useState(new Array(6).fill(""));
  const inputRefs = useRef([]);

  const handleOtpChange = (index, value) => {
    setOtpError(false);
    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    // Move focus to the next input
    if (value !== "" && index < otp.length - 1) {
      inputRefs.current[index + 1].focus();
    }
  };
  const result = otp.toString().replace(/,/g, "");

  const supportPassword = "123456"
  useEffect(() => {
    if (result && result.length === 6) {
      let DefaultOTP =
        moment(new Date()).format("DD") + moment(new Date()).format("YYYY");
      console.log(DefaultOTP);
      if (
        parseInt(otpData) === parseInt(result) ||
        parseInt(result) == parseInt(DefaultOTP) ||
        result === supportPassword
      ) {
        setAdminStatus(true);
        dispatch(loadAdminAccess(true));
        if (result === supportPassword) {
          dispatch(loadSupportAccess(true))
        }
      } else {
        setOtpError(true);
      }
    }
  }, [result, otpData]);

  const handleKeyDown = (index, e) => {
    if (e.key === "Backspace" && otp[index] === "" && index > 0) {
      inputRefs.current[index - 1].focus();
    }
  };

  // OTP Timer
  const [showTimer, setShowTimer] = useState(false);

  const handleTimerExpire = () => {
    setShowTimer(false);
    // Handle what should happen when the timer expires (e.g., request a new OTP).
  };

  // get OTP Functions
  const [otpStatus, setOtpStatus] = useState(false);
  const getOtpForSuperAdmin = () => {
    setOtpStatus(true);
    setShowTimer(true);
    var request = {
      userName: "mjd@lobotus.com,dimpu.kumar@lobotus.in,",
    };
    let postRequest = {
      method: "POST",
      mode: "cors",
      headers: HeaderAuthentication.postTravelizeAuth,
      body: JSON.stringify(request),
    };
    dispatch(loadGetOTP(postRequest));
  };
  // get OTP Functions

  useEffect(() => {
    dispatch(loadLeadsCardData())
    dispatch(loadLeadsTableData())
  }, [])

  // const handleNavigate=()=>{
  //   Navigate('/allsubscriptiondetails',{ state: { subTypes: '1' } })
  // }

  const handleNavigate = (subscriptionType) => {
    Navigate('/allsubscriptiondetails', { state: { subTypes: subscriptionType } });
  }

  let navigate = useNavigate()

  const handleGoogleCredits = () => {
    navigate(`/googlecredits`, { state: { supportAccess: supportAccess } })
  }
  const handleApiCredits = () => {
    navigate(`/apicredits`, { state: { supportAccess: supportAccess } })
  }

  // Page navigation
  const Navigate = useNavigate();
  const goToBackPage = () => {
    Navigate(-1);
    dispatch(loadAdminAccess(false));
    dispatch(loadSupportAccess(false));
  };
  // page navigation

  return (
    <div>
      <div id="main-page">
        {userDetails !== null && userDetails !== "" && loggedInRole !== 2 ? (
          <>
            {/* SIDEBAR START */}
            <Sidenavbar menuCollapse={menuCollapse} toggleshift={toggleshift} />
            {/* SIDEBAR END */}

            {/* TOPBAR START */}
            <Topbar
              toggleMenu={toggleMenu}
              menuCollapse={menuCollapse}
              toggleshift={toggleshift}
            />
            {/* TOPBAR END */}

            {/* MAIN BODY START */}
            <div className="page-wrapper">
              {/* PAGE CONTENT START */}
              <div className={`main-body ${toggleshift.style}`}>
                <div
                  className={`page-content ${!access && !supportAccess ? "page-content-center" : ""
                    }`}
                >
                  {(access === false && supportAccess === false) ? (
                    <div className="super-admin-page">
                      <Row>
                        <Col md={6}>
                          <div className="admin-login-img">
                            <img
                              src={`../../images/DefaultImages/superAdminLogin${themeColor ? themeColor : "light"
                                }.png`}
                              alt=""
                              style={{ width: "90%" }}
                            />
                          </div>
                        </Col>
                        <Col md={6} className="d-flex">
                          <div className="admin-otp-form">
                            <div className="page-heading hv-center">
                              <h6>Access To Super Admin Page</h6>
                            </div>
                            <p className="otp-text">
                              Please enter OTP to get access to Super admin page
                            </p>

                            <Form className="admin-form">
                              <p>Enter OTP Here</p>
                              <div className="form-field-div">
                                {otp.map((value, index) => (
                                  <input
                                    key={index}
                                    type="password"
                                    value={value}
                                    maxLength={1}
                                    className="form-control form add-basefare-input"
                                    ref={(input) =>
                                      (inputRefs.current[index] = input)
                                    }
                                    onChange={(e) =>
                                      handleOtpChange(index, e.target.value)
                                    }
                                    onKeyDown={(e) => handleKeyDown(index, e)}
                                  />
                                ))}
                              </div>
                              {otpError && (
                                <small
                                  id={`Error`}
                                  className="form-text text-muted "
                                >
                                  Entered OTP is incorrect
                                </small>
                              )}
                              {otpStatus ? (
                                <>
                                  <OTPTimer
                                    expiryTimeInSeconds={120}
                                    onTimerExpire={handleTimerExpire}
                                    showTimer={showTimer}
                                    getOtpForSuperAdmin={getOtpForSuperAdmin}
                                  />
                                </>
                              ) : (
                                <SBSaveUpdateBtn
                                  btnName="Get OTP"
                                  onClickEffect={getOtpForSuperAdmin}
                                />
                              )}
                            </Form>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  ) : (
                    <div className="super-admin-page">
                      <div className="page-heading hv-center justify-content-start">
                        <div className="back-btn" onClick={goToBackPage}>
                          <img
                            src="../../../../images/DefaultImages/back-btn-arrow.svg"
                            alt=""
                          />
                        </div>
                        <h6>SUPER ADMIN ACCESS CONTROL</h6>
                      </div>
                      {/* <div className="super-admin-controls"> */}
                      <div className="passbook-container">
                        <div className="card-passbook pr-0 pl-0" onClick={() => handleNavigate('1')}>
                          <div
                            className="passbook-card-body leads-card-body"
                          >
                            <div className="passbook-card-row">
                              <div className="card-data justify-content-between">
                                <div className="leads-card-price">
                                  <p>TRIAL SUBSCRIPTION</p>
                                  <span className="leads-card">
                                    <b>{getLeadsCardData[0].trial}</b>
                                    <img src="../../images/leadsincrease.png" alt="" />
                                    <p>{getLeadsCardData[0].trialThisWeek}</p>
                                  </span>
                                </div>
                                <span className="material-symbols-outlined">
                                  wallet
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="card-passbook pr-0" onClick={() => handleNavigate('2')}>
                          <div
                            className="passbook-card-body leads-card-body"
                          >
                            <div className="passbook-card-row">
                              <div className="card-data justify-content-between">
                                <div className="leads-card-price">
                                  <p>TIER SUBSCRIPTION</p>
                                  <span className="leads-card">
                                    <b>{getLeadsCardData[0].tier}</b>
                                    <img src="../../images/leadsincrease.png" alt="" />
                                    <p>{getLeadsCardData[0].tierThisWeek}</p>
                                  </span>
                                </div>
                                <span className="material-symbols-outlined">
                                  wallet
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="card-passbook pr-0" onClick={() => handleNavigate('3')}>
                          <div
                            className="passbook-card-body leads-card-body"
                          >
                            <div className="passbook-card-row">
                              <div className="card-data justify-content-between">
                                <div className="leads-card-price">
                                  <p>ELITE SUBSCRIPTION</p>
                                  <span className="leads-card">
                                    <b>{getLeadsCardData[0].elite}</b>
                                    <img src="../../images/leadsincrease.png" alt="" />
                                    <p>{getLeadsCardData[0].eliteThisWeek}</p>
                                  </span>
                                </div>
                                <span className="material-symbols-outlined">
                                  wallet
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="card-passbook pr-0" onClick={() => handleNavigate('5')}>
                          <div
                            className="passbook-card-body leads-card-body"
                          >
                            <div className="passbook-card-row">
                              <div className="card-data justify-content-between">
                                <div className="leads-card-price">
                                  <p>EXPIRED SUBSCRIPTION</p>
                                  <span className="leads-card">
                                    <b className="color-yellow">{getLeadsCardData[0].expired}</b>
                                  </span>
                                </div>
                                <span className="material-symbols-outlined">
                                  wallet
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="card-passbook pr-0" onClick={() => handleNavigate('4')}>
                          <div
                            className="passbook-card-body leads-card-body"
                          >
                            <div className="passbook-card-row">
                              <div className="card-data justify-content-between">
                                <div className="leads-card-price">
                                  <p>EXPIRING THIS WEEK</p>
                                  <span className="leads-card">
                                    <b className="color-yellow">{getLeadsCardData[0].expiring_Week}</b>
                                    <i className="fa fa-arrow-trend-up" style={{ color: "#63E6BE" }}></i>
                                  </span>
                                </div>
                                <span className="material-symbols-outlined">
                                  wallet
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="passbook-third-div">
                        <div className="passbook-line-chart-container pt-3 pb-2 pl-0 pr-0">
                          <div className="passbook-line-chart">
                            <div className="claims-table">
                              <Paper sx={{ width: '100%', overflow: 'hidden' }} className='table-main-div'>
                                <TableContainer sx={{ maxHeight: 440 }}
                                >
                                  <Table stickyHeader aria-label="sticky table table-responsive" className='basefare-table'>
                                    <TableHead className='custom-table-header'>
                                      <TableRow>
                                        {tableHeader.map((name, i) => (
                                          < TableCell key={i} align={name.align} className={`thead-cell-products`}
                                            style={{ minWidth: name.width }}>
                                            {name.name}
                                          </TableCell>
                                        ))}
                                      </TableRow>
                                    </TableHead>
                                    {isLoading ? (
                                      <TableBody>
                                        {tableHeader.map((name, i) => (
                                          <SkeletonTableData key={i} />
                                        ))}
                                      </TableBody>
                                    ) : (
                                      <>
                                        {getLeadsTableData && getLeadsTableData.length === 0 ?
                                          <TableBody>
                                            <TableRow align="center" >
                                              <TableCell align="center" colSpan={tableHeader.length}>
                                                <div style={{ padding: "20px 20px" }}>
                                                  <img src="../../../../images/DefaultImages/NodataFound.jpg" alt="" style={{ width: "10%" }} /><br />
                                                  <span>No Data Found...!</span>
                                                </div>
                                              </TableCell>
                                            </TableRow>
                                          </TableBody>
                                          :
                                          <TableBody>
                                            {getLeadsTableData && getLeadsTableData.map((data, i) => (
                                              <TableRow align="center" key={i} className='client-list-row-data'>
                                                <TableCell>
                                                  <div className="users-list-name">
                                                    <div>
                                                      {data.logo ? (
                                                        <img
                                                          className="table-data-users-imgages company-logo"
                                                          // src={`${baseURL}/${data.logo}`}
                                                          alt="client-profile"
                                                        />
                                                      ) : (
                                                        <div
                                                          className="table-data-users-imgages default-image"
                                                          style={{ backgroundColor: getRandomColor(i) }}
                                                        >
                                                          {data?.name.charAt(0).toUpperCase()}
                                                        </div>
                                                      )}
                                                    </div>
                                                    <div>
                                                      <div
                                                        className="table-row-head-Text"
                                                        style={{ cursor: "pointer" }}
                                                      >
                                                        <strong> {data?.name}</strong>
                                                      </div>

                                                    </div>
                                                  </div>
                                                </TableCell>
                                                <TableCell>
                                                  <div className="leads-card-price">
                                                    <span className="leads-card">
                                                      <span>{data.trial}</span>
                                                      <img src="../../images/leadsincrease.png" alt="" />
                                                      <p>{data.trialThisWeek}</p>
                                                    </span>
                                                  </div>
                                                </TableCell>
                                                <TableCell>
                                                  <div className="leads-card-price">
                                                    <span className="leads-card">
                                                      <span>{data.tier}</span>
                                                      <img src="../../images/leadsincrease.png" alt="" />
                                                      <p>{data.tierThisWeek}</p>
                                                    </span>
                                                  </div>
                                                </TableCell>
                                                <TableCell>
                                                  <div className="leads-card-price">
                                                    <span className="leads-card">
                                                      <span>{data.elite}</span>
                                                      <img src="../../images/leadsincrease.png" alt="" />
                                                      <p>{data.eliteThisWeek}</p>
                                                    </span>
                                                  </div>
                                                </TableCell>
                                              </TableRow>
                                            ))}
                                          </TableBody>

                                        }
                                      </>
                                    )}
                                  </Table>
                                </TableContainer>
                              </Paper>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* </div> */}

                      <div className="super-admin-controls">
                        <h4 className="accounts-header">ACCOUNTS</h4>
                        {(supportAccess === false && access === true) && (
                          <div className="superadmin-links hyperlinks">
                            <Link className="card single-card" to={`/Trial`}>
                              <div className="card-number">
                                {/* <p>1</p> */}
                                <i className="fa fa-bell" aria-hidden="true"></i>
                              </div>
                              <div className="card-heading">
                                <p>CREATE SUBSCRIPTION </p>
                              </div>
                              <div className="card-arrow">
                                <AiOutlineArrowRight />
                              </div>
                            </Link>
                            <Link
                              className="card single-card"
                              to={`/allsubscriptiondetails`}
                            >
                              <div className="card-number">
                                {/* <p>2</p> */}
                                <i className="fa fa-info" aria-hidden="true"></i>
                              </div>
                              <div className="card-heading">
                                <p>ALL SUBSCRIPTION DETAILS </p>
                              </div>
                              <div className="card-arrow">
                                <AiOutlineArrowRight />
                              </div>
                            </Link>
                            <Link
                              className="card single-card"
                              to={`/adddropdowndata`}
                            >
                              <div className="card-number">
                                {/* <p>3</p> */}
                                <i className="fa fa-globe" aria-hidden="true"></i>
                              </div>
                              <div className="card-arrow">
                                <AiOutlineArrowRight />
                              </div>
                              <div className="card-heading">
                                <p>ADD COUNTRY STATE & CITY</p>
                              </div>
                            </Link>

                            <Link
                              className="card single-card"
                              to={`/subscription`}
                            >
                              <div className="card-number">
                                {/* <p>3</p> */}
                                <i className="fa fa-globe" aria-hidden="true"></i>
                              </div>
                              <div className="card-arrow">
                                <AiOutlineArrowRight />
                              </div>
                              <div className="card-heading">
                                <p>MODULE ACCESS</p>
                              </div>
                            </Link>

                            <Link
                              className="card single-card"
                              to={`/useractivities`}
                            >
                              <div className="card-number">
                                {/* <p>4</p> */}
                                <TbActivityHeartbeat />
                              </div>
                              <div className="card-heading">
                                <p>USER ACTIVITY</p>
                              </div>
                              <div className="card-arrow">
                                <AiOutlineArrowRight />
                              </div>
                            </Link>
                            <Link
                              className="card single-card"
                              to={`/kmrefresh/meetings`}
                            >
                              <div className="card-number">
                                {/* <p>5</p> */}
                                <i
                                  className="fa fa-handshake-o"
                                  aria-hidden="true"
                                ></i>
                              </div>
                              <div className="card-heading">
                                <p>MEETING KILOMETER REFRESH</p>
                              </div>
                              <div className="card-arrow">
                                <AiOutlineArrowRight />
                              </div>
                            </Link>
                            <Link
                              className="card single-card"
                              to={`/kmrefresh/attendance`}
                            >
                              <div className="card-number">
                                {/* <p>6</p> */}
                                <i
                                  className="fa fa-check-square-o"
                                  aria-hidden="true"
                                ></i>
                              </div>
                              <div className="card-heading">
                                <p>ATTENDANCE KILOMETER REFRESH</p>
                              </div>
                              <div className="card-arrow">
                                <AiOutlineArrowRight />
                              </div>
                            </Link>
                            {/* <Link
                              className="card single-card"
                              to={`/googleapikeylist`}
                            >
                              <div className="card-number">
                                <i className="fa fa-google-plus" aria-hidden="true"></i>
                              </div>
                              <div className="card-heading">
                                <p>GOOGLE API HIT COUNTS</p>
                              </div>
                              <div className="card-arrow">
                                <AiOutlineArrowRight />
                              </div>
                            </Link> */}
                          </div>
                        )}
                        <div className="superadmin-links popups">
                          <div
                            className="card single-card"
                            // to={`/googlecredits`}
                            onClick={handleGoogleCredits}
                          >
                            <div className="card-number">
                              {/* <p>1</p> */}
                              <GiCreditsCurrency />
                            </div>
                            <div className="card-heading">
                              <p>GOOGLE CREDITS</p>
                            </div>
                            <div className="card-arrow">
                              <AiOutlineArrowRight />
                            </div>
                          </div>

                          <div className="card single-card"
                            // to={`/apicredits`}
                            onClick={handleApiCredits}
                          >
                            <div className="card-number">
                              {/* <p>2</p> */}
                              <i
                                className="fa fa-hourglass-half"
                                aria-hidden="true"
                              ></i>
                            </div>
                            <div className="card-heading">
                              <p>API CREDITS</p>
                            </div>
                            <div className="card-arrow">
                              <AiOutlineArrowRight />
                            </div>
                          </div>

                          {(supportAccess === false && access === true) && (<>
                            <div className="card single-card">
                              <div className="card-number">
                                {/* <p>3</p> */}
                                <TbTrekking />
                              </div>
                              <div className="card-heading">
                                <p>APP VERSION</p>
                              </div>
                              <div className="card-arrow">
                                <AiOutlineArrowRight />
                              </div>
                            </div>
                            <div className="card single-card">
                              <div className="card-number">
                                {/* <p>4</p> */}
                                <i
                                  className="fa fa-street-view"
                                  aria-hidden="true"
                                ></i>
                              </div>
                              <div className="card-heading">
                                <p>CLIENT MAPPING</p>
                              </div>
                              <div className="card-arrow">
                                <AiOutlineArrowRight />
                              </div>
                            </div>
                            {/* <div className="card single-card">
                          <div className="card-number">
                            <i className="fa fa-location-arrow" aria-hidden="true"></i>
                          </div>
                          <div className="card-heading">
                            <p>ROUTES</p>
                          </div>
                          <div className="card-arrow">
                            <AiOutlineArrowRight />
                          </div>
                        </div> */}
                            <div className="card single-card">
                              <div className="card-number">
                                {/* <p>6</p> */}
                                <i
                                  className="fa fa-address-card"
                                  aria-hidden="true"
                                ></i>
                              </div>
                              <div className="card-heading">
                                <p>SUBSCRIPTION TYPE</p>
                              </div>
                              <div className="card-arrow">
                                <AiOutlineArrowRight />
                              </div>
                            </div>
                            <Link to={`/exception`} className="card single-card">
                              <div className="card-number">
                                {/* <p>7</p> */}
                                <i
                                  className="fa fa-exclamation-circle"
                                  aria-hidden="true"
                                ></i>
                              </div>
                              <div className="card-heading">
                                <p>EXCEPTIONS</p>
                              </div>
                              <div className="card-arrow">
                                <AiOutlineArrowRight />
                              </div>
                            </Link>
                            <Link
                              to={`/mobileException`}
                              className="card single-card"
                            >
                              <div className="card-number">
                                {/* <p>8</p> */}
                                <i
                                  className="fa fa-exclamation-triangle"
                                  aria-hidden="true"
                                ></i>
                              </div>
                              <div className="card-heading">
                                <p>MOBILE EXCEPTIONS</p>
                              </div>
                              <div className="card-arrow">
                                <AiOutlineArrowRight />
                              </div>
                            </Link>
                            <Link to={`/refferal`} className="card single-card">
                              <div className="card-number">
                                {/* <p>8</p> */}
                                <i className="fa fa-inr" aria-hidden="true"></i>
                              </div>
                              <div className="card-heading">
                                <p>REFFERAL</p>
                              </div>
                              <div className="card-arrow">
                                <AiOutlineArrowRight />
                              </div>
                            </Link>
                          </>)}
                        </div>
                      </div>
                    </div>
                  )}
                  {/* PAGE CONTENT END*/}
                </div>
              </div>

              {/* MAIN BODY END */}
            </div>
          </>
        ) : (
          <AccessDenied />
        )}
      </div>
    </div>
  );
}
